import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const EyeIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 23.4 15.2",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 15.2),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m11.7.8c-4-.1-8 2.6-10.6 5.5-.5.6-.5 1.5 0 2.1 2.5 2.8 6.5 5.6 10.6 5.6 4 .1 8-2.7 10.5-5.5.5-.6.5-1.5 0-2.1-2.4-3-6.6-5.7-10.4-5.6h-.1z"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.3 7.4c0 2-1.7 3.7-3.7 3.7s-3.7-1.7-3.7-3.7 1.7-3.7 3.7-3.7h.2c2 .1 3.6 1.7 3.6 3.7z"
    })]
  });
};

export { EyeIcon };
//# sourceMappingURL=eye.js.map
